package com.cybersoftsolution.cybersoftsolutionweb.pages

import androidx.compose.runtime.*
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.DialogType
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.DisplayDialog
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.HomePageLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.RootPageLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.AboutSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.BannerSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.CommunitySection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.ContactSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.PageSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.ServiceSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.TechnologiesSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.WorkFlowSection
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.User
import com.cybersoftsolution.cybersoftsolutionweb.models.myServices
import com.cybersoftsolution.cybersoftsolutionweb.models.myTechnologies
import com.cybersoftsolution.cybersoftsolutionweb.models.ourWorkFlow
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.BannerSectionRadialGradientStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserInfo
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.logout
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


@Page
@Composable
fun HomePage() {

    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val context = rememberPageContext()

    var displayDialog by remember { mutableStateOf(DisplayDialog(DialogType.None,null)) }
    var toastMessage by remember { mutableStateOf( ToastMessage()) }

    fun dismissDialog(){
        displayDialog = DisplayDialog(DialogType.None,null)
    }

    RootPageLayout(
        displayDialog = displayDialog,
        incomeToastMessage = toastMessage,
        onDismiss = {
            dismissDialog()
        },
        onLogout = {
            logout()
            dismissDialog()
            toastMessage = ToastMessage(message = "Sesión Cerrada satisfactoriamente", style = MyToastStyle.Success)
        },
        onLogin = { success, message ->
            toastMessage = if (success) {
                dismissDialog()
                ToastMessage(message = "Sesión Iniciada satisfactoriamente", style = MyToastStyle.Success)
            } else {
                ToastMessage(message = message?: "Error desconocido", style = MyToastStyle.Danger)
            }
        },
        onRegister = { success, message ->
            toastMessage = if (success) {
                ToastMessage(message = message?: "Registro Exitoso, sesión iniciada", style = MyToastStyle.Success)
            } else {
                ToastMessage(message = message?: "Error desconocido", style = MyToastStyle.Danger)
            }
        },
        onRestorePassword = { success, message ->
            toastMessage = if (success) {
                ToastMessage(message = message?: "Contraseña restablecida y sesión iniciada", style = MyToastStyle.Success)
            } else {
                ToastMessage(message = message?: "Error desconocido", style = MyToastStyle.Danger)
            }
        },
        showSignUpDialog = {
            dismissDialog()
            displayDialog = DisplayDialog(DialogType.SignUp,null)
        },
        showSignInDialog = {
            dismissDialog()
            displayDialog = DisplayDialog(DialogType.SignIn,null)
        },
        showProfileDialog = {
//            dismissDialog()
            displayDialog = DisplayDialog(DialogType.Profile,getUserInfo())
        }

    ){

        HomePageLayout(
            authenticatedUserInfo = getUserInfo(),
            displayAuthenticationDialog = {
                val userInfo = getUserInfo()
                if (userInfo.id.isNullOrEmpty() || userInfo.authorizationToken.isNullOrEmpty()) {
                    displayDialog = DisplayDialog(DialogType.SignIn,userInfo)
                } else {
                    displayDialog = DisplayDialog(DialogType.Profile,userInfo)
                }
            }
        ){


            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top,
                modifier = Modifier
                    .fillMaxSize()
            ){

                BannerSection(
                    sectionModifier = BannerSectionRadialGradientStyle.toModifier()
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(if (isDesktop()) {70.percent} else {95.percent}),
                    pageSection = PageSection.BannerSection,
                    brandIcon = Resources.Images.icoLogo,
                    banner = Resources.Images.bannerSvg,
                    title = "Impulsa tu Marca con software personalizado \uD83D\uDE42",
                    subtitle = "Buscas software personalizado para optimizar tus procesos o darle visibilidad online a tu emprendimiento ?",
                    text = "Convertimos de tu idea, en una solución tecnológica \"a la medida\" para que puedas enfocarte en lo que realmente importa",
                    buttonText = "Contactanos y obtén un estimado gratis"
                )

                ServiceSection(
                    services = myServices,
                    sectionModifier = Modifier
                        .backgroundColor(Theme.LightGray.rgb)
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(if (isDesktop()) {70.percent} else {95.percent}),
                    pageSection = PageSection.ServicesSection,
                    title = "Servicios y Soluciones",
                )

                ContactSection(
                    pageSection = PageSection.ContactSection,
                    sectionModifier = Modifier
                        .backgroundColor(Theme.LightDarkGray.rgb)
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(if (isDesktop()) {40.percent} else {95.percent}),

                    )

                AboutSection(
                    sectionModifier = Modifier
                        .backgroundColor(Theme.LightGray.rgb)
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(if (isDesktop()) {70.percent} else {95.percent}),
                    pageSection = PageSection.AboutSection,
                    title = "Sobre nosotros ...",
                )

//                CommunitySection(
//                    title = "Comunidad",
//                    users = listOf(
//                        User(
//                            id = "jc",
//                            email = "juanca@gmail.com",
//                            phone = "phone",
//                            password = "",
//                            name = "Juan Carlos",
//                            isAdmin = true,
//                            isEnable = true,
//                            authorizationToken = ""
//                        )
//                    ),
//
//
//                    pageSection = PageSection.CommunitySection,
//                    sectionModifier = Modifier
//                        .backgroundColor(Theme.LightDarkGray.rgb)
//                        .fillMaxWidth(),
//                    contentModifier = Modifier
//                        .margin(topBottom = 30.px)
//                        .fillMaxWidth(
//                            when (breakpoint) {
//                                Breakpoint.ZERO -> 95.percent
//                                Breakpoint.SM -> 95.percent
//                                Breakpoint.MD -> 75.percent
//                                else -> 60.percent
//
//                            }
//                        )
//                )


                WorkFlowSection(
                    workFlow = ourWorkFlow,
                    sectionModifier = Modifier
                        .backgroundColor(Theme.LightGray.rgb)
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(if (isDesktop()) {70.percent} else {95.percent}),
                    pageSection = PageSection.WorkFlowSection,
                    title = "Flujo de trabajo",
                )

                TechnologiesSection(
                    title = "Tecnologías",
                    technologies = myTechnologies,
                    pageSection = PageSection.TechnologySection,
                    sectionModifier = Modifier
                        .backgroundColor(Theme.LightDarkGray.rgb)
                        .fillMaxWidth(),
                    contentModifier = Modifier
                        .margin(topBottom = 30.px)
                        .fillMaxWidth(
                            when (breakpoint) {
                                Breakpoint.ZERO -> 95.percent
                                Breakpoint.SM -> 95.percent
                                Breakpoint.MD -> 75.percent
                                else -> 60.percent

                            }
                        )
                )


            }




        }

    }






}
